// @mui
import { Card, Typography } from '@mui/material';
// utils
import { fData } from '../../../utils/formatNumber';

export default function AppWidgetSummary({ is_percentage, by, title, value, icon, color = 'primary', sx, ...other }) {
  return (
    <Card
      sx={{
        py: 1,
        textAlign: 'center',
        alignItems: 'center',
        color: 'gray',
        // flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingX: 2,
        ...sx,
      }}
      variant='outlined'
      {...other}
    >
      <div>{icon}</div>
      <div>
        <Typography variant="h3" fontWeight={400}>
          { is_percentage ?
            ( value + '%') :
            (by === 'count' ? value : String(fData(value)).toUpperCase())
          }
          
        </Typography>
      </div>
    </Card>
  );
}
